
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Card from '../../components/base/Card';
import { useEffect, useState } from 'react';
import { isAdminOrSuper, isSuperAdmin } from '../../utils/roleHelpers';

export default function Home() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('User');

  useEffect(() => {
    // Get username from localStorage if available
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const cards = [
    {
      title: 'Parser Creation',
      description: 'Create new document parsers or modify existing ones',
      icon: 'ri-file-add-line',
      onClick: () => navigate('/parser-creation')
    },
    {
      title: 'Templates',
      description: 'Browse and use prebuilt document templates',
      icon: 'ri-file-line',
      onClick: () => navigate('/templates')
    },
    {
      title: 'Playground',
      description: 'Test and experiment with your parsers',
      icon: 'ri-play-circle-line',
      onClick: () => navigate('/playground')
    }
  ];

  const superAdminCards = [
    {
      title: 'Admin Master',
      description: 'View all admins with company ID and description',
      icon: 'ri-shield-user-line',
      onClick: () => navigate('/admin-master')
    }
  ];

  const adminCards = [
    {
      title: 'User Management',
      description: 'Create users and admins, manage passwords',
      icon: 'ri-user-settings-line',
      onClick: () => navigate('/user-management')
    }
  ];

  const isAdmin = isAdminOrSuper(); // Check for both admin and super_admin
  const isSuper = isSuperAdmin(); // Check for super_admin only
  const goLogs = () => navigate('/admin-panel');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <Navbar showUserActions={true} />
      
      <div className="flex flex-col items-center px-4 py-8">
        <div className="w-full max-w-6xl">
          <div className="flex items-center justify-between mb-12">
            <div className="text-left">
              <h1 className="text-4xl font-bold text-gray-800 mb-2">Welcome to Document Parser Extractor</h1>
              <div className="w-full h-px bg-gray-300"></div>
            </div>
            {isAdmin && (
              <button
                onClick={goLogs}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line mr-2"></i>
                Logs
              </button>
            )}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {cards.map((card, index) => (
              <Card key={index} onClick={card.onClick} className="text-center">
                <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-100`}>
                  <i className={`${card.icon} text-2xl text-indigo-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{card.title}</h3>
                <p className="text-gray-600">{card.description}</p>
              </Card>
            ))}
          </div>

          {/* Admin/Super Admin Cards */}
          {isAdmin && (
            <div className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Admin Master - Only for super_admin */}
                {isSuper && superAdminCards.map((card, index) => (
                  <Card key={index} onClick={card.onClick} className="text-center">
                    <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100`}>
                      <i className={`${card.icon} text-2xl text-purple-600`}></i>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{card.title}</h3>
                    <p className="text-gray-600">{card.description}</p>
                  </Card>
                ))}
                {/* User Management - For both admin and super_admin */}
                {adminCards.map((card, index) => (
                  <Card key={index} onClick={card.onClick} className="text-center">
                    <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100`}>
                      <i className={`${card.icon} text-2xl text-purple-600`}></i>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">{card.title}</h3>
                    <p className="text-gray-600">{card.description}</p>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
